import * as React from 'react';
import {ReactNode} from 'react';

import {H1, H2, H3, H4} from './styled';

function getTitle(size: 1 | 2 | 3 | 4) {
    switch (size) {
        case 1:
        default:
            return H1;
        case 2:
            return H2;
        case 3:
            return H3;
        case 4:
            return H4;
    }
}

interface Props {
    className?: string;
    style?: React.CSSProperties;
    children: ReactNode;
    size: 1 | 2 | 3 | 4;
}

export function Title({className, children, size, style}: Props) {
    const TitleElement = getTitle(size);
    return (
        <TitleElement className={className} style={style}>
            {children}
        </TitleElement>
    );
}
